import { ShiftTypes } from '@/types';

export const SHIFT_TYPES = [
  { label: 'Открытие смены', value: ShiftTypes.OPEN },
  { label: 'Закрытие смены', value: ShiftTypes.CLOSE },
];
